import React from "react"
import {
    componentStyles,
    Drawer,
    DrawerPlacement,
} from "@mallardbay/lib-react-components"

import TextLogo from "~components/shared/header/logo"
import SidebarContent from "~components/shared/sidebar/sidebar-content"
import { usePageLayout } from "~contexts/page-layout-provider"
import { TEST_IDS } from "~config/constants"

import SidebarVersion from "./sidebar-version"
import { hiddenScrollbarStyles } from "./hidden-scrollbar-styles"

export default function SidebarDrawer() {
    const { isSidebarOpen, closeSidebar } = usePageLayout()
    const styles = useStyles()
    return (
        <Drawer
            testId={TEST_IDS.SIDEBAR_DRAWER}
            placement={DrawerPlacement.Left}
            isOpen={isSidebarOpen}
            onClose={closeSidebar}
            style={styles.drawer}
        >
            <TextLogo style={{ paddingY: 1, paddingLeft: 10 }} />

            <SidebarContent isCollapsed={false} />

            <SidebarVersion />
        </Drawer>
    )
}

function useStyles() {
    return componentStyles({
        drawer: {
            overflowX: "hidden",
            ...hiddenScrollbarStyles,
        },
    })
}
